import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HashRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import InvoiceList from '../pages/Invoice';
import InvoiceDetail from '../pages/InvoiceDetail.tsx';
import CargoInvoiceDetail from '../pages/CargoInvoicePreview';

export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path={'/'} element={<InvoiceList />} />
          <Route path={'/invoicedetail/:id'} element={<InvoiceDetail />} />
          <Route
            path={'/cargo-invoice-preview/:id'}
            element={<CargoInvoiceDetail />}
          />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
